var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3059 1.04351L11.3205 4.9908C11.1418 5.70663 10.5835 6.26594 9.868 6.44594L7.5432 7.03077C7.15203 7.12917 6.82295 7.39274 6.64149 7.75297C6.25238 8.52542 5.25963 8.75822 4.56762 8.23948L1.52733 5.96027M12.3059 1.04351C11.5677 0.859429 10.7952 0.761719 10 0.761719C6.30154 0.761719 3.0967 2.87518 1.52733 5.96027M12.3059 1.04351C16.4383 2.07389 19.5 5.81026 19.5 10.2617C19.5 15.5084 15.2467 19.7617 10 19.7617C4.75329 19.7617 0.5 15.5084 0.5 10.2617C0.5 8.71352 0.87037 7.25174 1.52733 5.96027M9.4093 14.5063L8.5247 13.1794C8.1901 12.6774 8.2569 12.009 8.6842 11.5832C8.9409 11.3274 9.2951 11.1941 9.6567 11.2172L10.544 11.2738C10.8973 11.2964 11.2383 11.4123 11.5321 11.6098L12.9916 12.5905C13.6318 13.0207 13.8528 13.8593 13.5079 14.5492C13.2482 15.0687 12.7172 15.3969 12.1363 15.3969H11.0734C10.4047 15.3969 9.7802 15.0627 9.4093 14.5063Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.5b7ef9206ea90c32c0cd6dc290eb89ad.svg";
export { ForwardRef as ReactComponent };